import { render, staticRenderFns } from "./ConfiguracaoImpressao.vue?vue&type=template&id=c9fdabf2&scoped=true"
import script from "./ConfiguracaoImpressao.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoImpressao.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoImpressao.vue?vue&type=style&index=0&id=c9fdabf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fdabf2",
  null
  
)

export default component.exports